import { useEffect, useMemo, useState } from "react";

import { t } from "i18next";

import Typology from "components/Custom/Typology";

import { TYPE } from "../../constants";
import AdvancedInput2 from "components/Custom/AdvancedInput2";

const ReviewType = ({
	alternativeIndex,
	value,
	dictionary,
	setRightMenuPannel,
	language,
	languages,
	onChangePath,
	contact,
	location,
	link,
	menu,
	attachments,
	isEditMode,
	typologyType,
	channelType,
	locationRequest,
	code,
	stepTypeSelected
}) => {
	const [lastUpdate, setLastUpdate] = useState("");
	const [triggerMemo, setTriggerMemo] = useState(false);

	useEffect(() => {
		if (lastUpdate !== value) {
			setTriggerMemo(prev => !prev);
		}

		if (channelType === TYPE.steps && stepTypeSelected === "solution") {
			onChangePath("text", undefined);
		}
	}, [value]);

	return (
		/**
		 * useMemo permet de rendre le composant uniquement lorsque triggerMemo change
		 * sinon, le composant serait re-rendu à chaque frappe de clavier
		 * ce qui causerait des problèmes de performance et des bugs visuels
		 */
		useMemo(() => {
			if (channelType === TYPE.review)
				return (
					<AdvancedInput2
						dictionary={dictionary}
						value={value}
						onChange={e => {
							setLastUpdate(prev => e);
							onChangePath("text", e);
						}}
						placeholder={t("COMPONENT.ANSWERTYPE.typeAnswer")}
						trigger={triggerMemo}
						onFocus={() => {
							setRightMenuPannel({
								open: true,
								alternative: alternativeIndex,
								language: language.code,
								languages,
								channelType
							});
						}}
					/>
				);
			return (
				<Typology
					dictionary={dictionary}
					value={value}
					onChangePath={(type, e) => {
						onChangePath(type, e);
						setLastUpdate(prev => e);
					}}
					location={location}
					link={link}
					menu={menu}
					attachments={attachments}
					isEditMode={isEditMode}
					typologyType={typologyType}
					stepTypeSelected={stepTypeSelected}
					locationRequest={locationRequest}
					language={language.code}
					code={code}
					contact={contact}
					alternativeIndex={alternativeIndex}
				/>
			);
		}, [
			triggerMemo,
			typologyType,
			stepTypeSelected,
			alternativeIndex,
			contact,
			location,
			link,
			menu
		])
	);
};

export default ReviewType;
